angular.module('app').factory('ConvertService', () => {
    return {
        ToDictionary: ToDictionary
    };
    function ToDictionary(keyValues) {
        let dict = {};
        let i;
        for (i = 0; i < keyValues.length; i++) {
            let item = keyValues[i];
            dict[item.Name] = item.Value;
        }
        return dict;
    }
});
